<template>
  <div>
   
       <template v-if="isCallingApi">
     <div class="flex-container">

        <div>
          <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div>
              </div><div></div><div></div><div></div><div></div><div></div><div></div></div>

        </div>

         <div class="distanceWord">LOADING</div>

     </div>
    
    
        
       
    </template>


   



      
    <md-content v-if="hasApiError" class="md-accent">
      <div v-if="apiError.errorType">{{apiError.errorType}}</div>
      <div v-if="apiError.errorMessage">{{apiError.errorMessage}}</div>
      <div v-if="apiError.debugCode">Api Error({{apiError.debugCode}})</div>
      <div class="md-accent" v-for="msg in apiError.messages">{{msg}}</div>
    </md-content>
    <slot v-if="!isCallingApi"/>

  </div>
</template>

<style scoped>

.fullBox {
     background: #74a6f2;
     text-align: left;
     margin: auto; 
}


.distanceWord {
    padding-left: 50px;
    font-size: 20px;
    font-weight: 600;
    margin: auto; 
    text-align: center;
    display: inline-block;
    
}

.location {
   
}


.flex-container {
  display: flex;
  flex-wrap: nowrap;
 
}

.flex-container > div {
  
  width: 20px;
  margin-left: 5px;
  text-align: center;
  line-height: 30px;
  font-size: 20px;
}

.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-spinner div {
  transform-origin: 32px 32px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 29px;
  width: 5px;
  height: 14px;
  border-radius: 20%;
  background: rgb(170, 163, 163);
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}


</style>


<script>
  export default {
    name: 'calling-api',
    props: {
      path: String,
      paths: Array,
      type: String,
      once: Boolean,
      notDisplayError: Boolean,
    },
    data: () => ({ called: false }),
    watch: {
      isCallingApi(newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.called = true;
        }
      }
    },
    computed: {
      isCallingApi() {
        if (this.once && this.called) {
          return false;
        }
        const find = _(this.$store.state.callingApis).filter(it => it.calling > 0).find(it => it.apiPath === this.path || (this.paths && _(this.paths).contains(it.apiPath)));
        return !!find;
      },
      hasApiError() {
        return !!this.apiError && !this.notDisplayError;
      },
      apiError() {
        const find = _(this.$store.state.apiErrorResponses).filter(it=>!!it.errorRes).find(it => it.apiPath === this.path || (this.paths && _(this.paths).contains(it.apiPath)));
        if (find) {
          return find.errorRes;
        }
        return find;
      },
      getDiameter() {
        if (this.isCallingApi) {
          return 50;
        }
        return 0;
      },
      getStyle() {
        if (!this.isCallingApi) {
          return {
            display: 'none',
          };
        }
        return {};
      }
    }
  }
</script>
